<template>
  <v-card>
    <v-toolbar color="primary" dark>
      <v-tooltip bottom>
        <v-btn flat icon @click="$router.go(-1)" slot="activator">
          <v-icon>far fa-arrow-left</v-icon>
        </v-btn>
        <span>Back</span>
      </v-tooltip>
      <v-toolbar-title>Marking Guide</v-toolbar-title>
      <v-spacer />
      <small>
        Last modified on {{
          (current && current.updatedAt) || new Date() | moment('DD/MM/YYYY')
        }} by {{
          current && current.creator && current.creator.name
        }}
      </small>
      <v-tooltip bottom v-if="$store.state.auth.user.perm === 'admin'">
        <v-btn flat icon :to="'?heuristic&edit'" slot="activator">
          <v-icon>fal fa-edit</v-icon>
        </v-btn>
        <span>Edit</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text>
      <viewer v-if="current" v-model="current.text" :options="options"/>
    </v-card-text>
  </v-card>
</template>
<script>
/* eslint-disable no-extraneous-dependencies */
// import 'tui-editor/dist/tui-editor-contents.css';
import 'tui-editor/dist/tui-editor.css';
import 'tui-chart/dist/tui-chart.min.css';
import 'tui-color-picker/dist/tui-color-picker.min.css';
import { Viewer } from '@toast-ui/vue-editor';
import 'tui-color-picker';
import 'raphael';
import 'tui-chart';
import 'tui-editor/dist/tui-editor-extScrollSync';
import 'tui-editor/dist/tui-editor-extTable';
import 'tui-editor/dist/tui-editor-extUML';
import 'tui-editor/dist/tui-editor-extColorSyntax';
import 'tui-editor/dist/tui-editor-extChart';
import { mapGetters } from 'vuex';

const chart = {
  name: 'chart',
  minWidth: 100,
  maxWidth: 600,
  minHeight: 100,
  maxHeight: 300,
};

export default {
  components: {
    viewer: Viewer,
  },
  props: {
    toolbar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      options: {
        usageStatistics: false,
        exts: ['scrollSync', 'colorSyntax', 'uml', chart, 'table'],
      },
    };
  },
  computed: {
    ...mapGetters('heuristics', ['current']),
  },
};
</script>

<style lang="stylus">
.tui-editor-defaultUI
  font-family Roboto,sans-serif
.tui-editor-contents
  h1, h2, h3, h4, h5, h6, li
    margin-bottom 0.5em
  table
    margin: 2px 0 14px;
    color: #555;
    width: auto;
    border-collapse: collapse;
    box-sizing: border-box;
  th, td
    height: 32px;
    padding: 5px 14px 5px 12px;
  td
    border: 1px solid #eaeaea;
  th
    border: 1px solid #72777b;
    border-top: 0;
    background-color: #7b8184;
    font-weight: 300;
    color: #fff;
    padding-top: 6px;
  .task-list-item
    border: 0;
    list-style: none;
    padding-left: 22px;
    margin-left: -22px;
    position relative
  .task-list-item::after
    font-family: "Font Awesome 5 Pro";
    font-weight: 400;
    position absolute
    content "\f0c8"
    left 0
    top 0
  .task-list-item.checked::after
    font-weight 900
    content "\f14a"
  .task-list-item input[type='checkbox'],
  .task-list-item .task-list-item-checkbox
    margin-left: -17px;
    margin-right: 3.8px;
    margin-top: 3px;
  code
    width: 100%;
  code::after,
  code::before,
  kbd::after,
  kbd::before
    width: 100%;
    display: inline-block;
  img
    max-width 100%
</style>
